import { Theme, colorGradients } from './theme-types'

const primary = "#53629E" // "#3182CE"
const dark = "#222222"

const darkTheme: Theme = {
  name: 'dark',
  dark: true,
  colors: {
    primary: primary,

    // background colors
    bgMain: "#1a1a1a",
    bgSecond: "#262626",
    bgAlt: '#242A34',

    // button colors
    buttonAlt: '#459BA0',

  // text colors
    textMain: '#ffffff',
    textSecond: '#B1B1B1',
    textAlt: '#aaaaaa',
    placeholder: '#aaaaaa',

    // state colors
    success: "#1DCC70",
    danger: "#FF396F",
    warning: "#FFB400",
    info: "#05D0A4",
    disabled: "#D2D2D2",

    // border colors
    borderColor: "#DCDCE9",
    shadowColor: "#9c9c9c",

    // transactions
    bgTransaction: dark,

    // navigation
    statusBarStyle: 'dark',
    tabBackground: dark,
    tabInactiveText: '#aaaaaa',
    tabActiveText: primary,
    headerBackground: primary,
    headerText: '#ffffff',
    footerBackground: primary,

    // loading animation colors
    loadingAnimation: {
      color1: colorGradients.gray[400],
      color2: primary,
      color3: colorGradients.gray[400],
    },
    skeletonLoader: '#2A2D33',

    // scrollbar colors
    scrollbarThumb: '#707070',

    // extra palette colors
    second: "#8494A8",
    dark: "#222222",
    darkAccent: "#002150",
    lightAccent: "#8a97d2",
    white: '#ffffff',
    
    ...colorGradients,
  },
}

export default darkTheme